import { Input } from '@tencent/udesign/dist';
import { useEffect, useState } from 'react';
import { ITableFilterInput } from '../../model';

interface IProps<T> {
  readonly onChanged: (key: string, value: string) => void;
  readonly columnKey: string;
  readonly value: string | string[];
  readonly filters: ITableFilterInput<T>;
}

export function FilterInputComponent<T>(props: IProps<T>) {
  const [value, setValue] = useState<string>('');

  const getValue = (value: string | string[]) => {
    return value ? value.toString() : '';
  };

  const onChange = (value: string) => {
    setValue(value);
  };

  const onBlur = () => {
    props.onChanged(props.columnKey, value);
  };

  useEffect(() => {
    const value = getValue(props.value);
    setValue(value);
  }, [props.value]);

  return (
    <Input
      type="text"
      size="tiny"
      value={value}
      onBlur={onBlur}
      icon="mdi-filter"
      onChange={onChange}
      allowClear={true}
      {...props.filters.extension}
    />
  );
}
